import {GraphQLClient} from 'graphql-request';

export function baseURL() {
    const { protocol, host } = window.location;
    return new URL(`${protocol}//${host}`);
}

export function publicDirURL () {
    return (new URL("_resources/app-page/javascript/node_modules/@manaakiwhenua/oe-report-elements/public", baseURL())) + '';
}

let gqlPromise;

function requestToken() {
    return fetch('/GeoFeature/token')
        .then((resp) => resp.json());
}

export async function authHeader() {
    const token = await requestToken();
    if (token && token.token) {
        return {
            'Authorization': `Bearer ${token.token}`
        };
    }

    return {};
}

export function graphQLClient () {
    gqlPromise = gqlPromise || authHeader()
        .then(headers => {
            return new GraphQLClient('/reportApi/graphql', {headers});
        });

    return gqlPromise;
}


